import {
  Button,
  DialogFooter,
  HexIcon,
  Icons,
  ExternalLink,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import {
  ClusterDialogTitle,
  DialogHeading,
  StepContainer,
} from 'hooks/dialogs/cluster/_components/new-onboarding';

import { getDocsLink } from '@cast/utils';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  onRetry: () => void;
  onClose: () => void;
};

export const ErrorStep = ({ onRetry, onClose }: Props) => {
  return (
    <StepContainer data-testid="castctl-connecting-failed-step">
      <DialogHeading onClose={onClose} hideTerraformLink>
        <Stack direction="row" gap={10} alignItems="center">
          <HexIcon
            variant="error"
            size={28}
            animationType="pulsateSlow"
            icon={<Icons.XCircle />}
          />
          <ClusterDialogTitle>Failed to connect</ClusterDialogTitle>
        </Stack>
      </DialogHeading>

      <Box
        component="ul"
        sx={{
          px: 24,
          pl: 72,
          my: 0,
          py: 0,
          '& li': {
            typography: 'P12R',
            color: tokens.theme.fg.structural.secondary,
          },
        }}
      >
        <li>Check the terminal for details about the error</li>
        <li>
          Ensure the cluster is not already connected to another organization
        </li>
        <li>Check that you&apos;ve run the script in the right context</li>
        <li>
          Check our{' '}
          <ExternalLink
            sx={{ typography: 'P12R' }}
            link={getDocsLink('docs')}
            noIcon
          >
            documentation
          </ExternalLink>{' '}
          or ask a question on our{' '}
          <ExternalLink
            sx={{ typography: 'P12R' }}
            link={EXTERNAL_LINKS.castai_slack_community}
            noIcon
          >
            Community Slack
          </ExternalLink>
        </li>
      </Box>

      <DialogFooter
        sx={{ borderTop: 'none' }}
        end={
          <>
            <Button
              variant="secondary"
              onClick={onClose}
              testId="castctl-error-close-button"
            >
              Close
            </Button>
            <Button onClick={onRetry} testId="castctl-error-retry-button">
              Retry
            </Button>
          </>
        }
      />
    </StepContainer>
  );
};
